import { JSX, useEffect, useRef } from 'react'

import { IPosition } from '../PinOutPortal'
import pinStyles from '../PinOutPortal.module.scss'

import styles from './PortalChild.module.scss'

interface IProps {
  children: JSX.Element | Array<JSX.Element>
  moveWidget: boolean
  pinOut: boolean
  widgetId: string
  setSavedPos: (pos: IPosition) => void
  style: any
}
let mouseMoveHandler: any = null
let mouseUpHandler: any = null
export const PortalChild = (props: IProps) => {
  const ref = useRef(null)
  const hdlDrag = () => {
    let prevMouseY: number
    let prevMouseX: number
    let deltaY = 0
    let deltaX = 0
    mouseMoveHandler = (e: MouseEvent) => {
      e.preventDefault()
      if (e.clientY > 0 && e.clientX > 0) {
        deltaY = !prevMouseY ? 0 : prevMouseY - e.clientY
        deltaX = !prevMouseY ? 0 : prevMouseX - e.clientX
        prevMouseY = e.clientY
        prevMouseX = e.clientX
        if (ref.current !== null) {
          const currRef = ref.current
          //@ts-ignore
          const rect = currRef.getBoundingClientRect()
          if (rect.top - deltaY > -10) {
            //@ts-ignore
            currRef.style.top = `${currRef.offsetTop - deltaY}px`
          }
          if (rect.left - deltaX > -10) {
            //@ts-ignore
            currRef.style.left = `${currRef.offsetLeft - deltaX}px`
          }
        }
      }
    }
    document.addEventListener('mousemove', mouseMoveHandler)
  }

  useEffect(() => {
    if (props.moveWidget) {
      hdlDrag()
    } else {
      let currentRef: HTMLDivElement | null = ref.current
      if (currentRef) {
        currentRef = currentRef as HTMLDivElement
        if (currentRef.offsetTop) {
          const res = localStorage.getItem('pin_out_widgets')
          const res2 = JSON.parse(res || '{}')
          const currentValue = res2[props.widgetId]
          localStorage.setItem(
            `pin_out_widgets`,
            JSON.stringify({
              ...res2,
              [props.widgetId]: {
                pinOut: true,
                hidePinOut: currentValue.hidePinOut || false,
                top: currentRef.getBoundingClientRect().top,
                left: currentRef.getBoundingClientRect().left,
                height: currentRef.offsetHeight,
                width: currentRef.offsetWidth,
              },
            })
          )
        }

        document.removeEventListener('mousemove', mouseMoveHandler)
      }
    }
  }, [props.moveWidget])

  const resize = (arg: boolean) => {
    let prevMouseY: number = 0
    let prevMouseX: number = 0
    let deltaY = 0
    let deltaX = 0
    if (arg) {
      mouseMoveHandler = (e: MouseEvent) => {
        deltaY = !prevMouseY ? 0 : prevMouseY - e.clientY
        deltaX = !prevMouseY ? 0 : prevMouseX - e.clientX
        prevMouseY = e.clientY
        prevMouseX = e.clientX
        let currRef: HTMLDivElement | null = null
        if (ref.current) {
          currRef = ref.current
        }
        if (currRef) {
          currRef = currRef as HTMLDivElement
          const height = currRef.offsetHeight
          const width = currRef.offsetWidth
          const deltaWidth = width - deltaX
          const deltaHeight = height - deltaY
          if (deltaHeight >= 200) {
            const newHeight = `${deltaHeight}px`
            currRef.style.height = newHeight
          }
          if (deltaWidth >= 200) {
            const newWidth = `${deltaWidth}px`
            currRef.style.width = newWidth
          }
          e.preventDefault()
          e.stopPropagation()
        }
      }
      mouseUpHandler = () => {
        resize(false)
      }
      document.addEventListener('mousemove', mouseMoveHandler)
      document.addEventListener('mouseup', mouseUpHandler)
    } else if (mouseMoveHandler) {
      document.removeEventListener('mousemove', mouseMoveHandler)
      document.removeEventListener('mouseup', mouseUpHandler)
      mouseMoveHandler = null
      mouseUpHandler = null
    }
  }

  return (
    <div style={props.style} className={pinStyles['widget-wrapper']} ref={ref}>
      {props.children}
      <div className={styles.bottomLine}>
        <div className={styles.moveContainer} onMouseDown={() => resize(true)}>
          <i className={'kbase kbase-expand'} />
          <span className={styles.resizeText}>resize</span>
        </div>
      </div>
    </div>
  )
}
